import { Badge } from "@-/dev.improve.haniverse.components.ui.badge";
import { Text } from "@-/dev.improve.haniverse.components.ui.text";

/** The outline pill above an Overview glyph: the card's grade (`HSK 1`) or usage (`Tier 1`). */
export function MorphemeInfoPanelDictionaryGradeBadge({ label }: { label: string }) {
  return (
    <Badge variant="outline">
      <Text className="text-xs font-semibold tracking-wide uppercase">{label}</Text>
    </Badge>
  );
}
